<div id="billing-container" *ngIf="this.electronicBillingData">
  <div id="main-container">
    <!-- Form container -->
    <div class="form-container">
      <!-- Razón social -->
      <div class="item-container">
        <p class="heading-02-bold title">Razón social</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.razonSocial }}
        </p>
      </div>
      <!-- Razón social -->
      <!-- Dirección -->
      <div class="item-container">
        <p class="heading-02-bold title">Dirección</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.calle }}
        </p>
      </div>
      <!-- Dirección -->
           <!-- Teléfono  -->
           <div class="item-container">
            <p class="heading-02-bold title">Número</p>
            <p class="paragraph-01-regular data">
              {{ this.electronicBillingData.numero }}
            </p>
          </div>
          <!-- Teléfono  -->
      <!-- Provincia -->
      <div class="item-container">
        <p class="heading-02-bold title">Provincia</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.provincia }}
        </p>
      </div>
      <!-- Provincia -->
      <!-- Localidad -->
      <div class="item-container">
        <p class="heading-02-bold title">Localidad</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.localidad }}
        </p>
      </div>
      <!-- Localidad -->
 
      <!-- Condición frente al IVA -->
      <div class="item-container">
        <p class="heading-02-bold title">Condición frente al IVA</p>
        <p
          *ngIf="this.electronicBillingData.emisorTipo == 1"
          class="paragraph-01-regular data"
        >
          Responsable inscripto
        </p>
        <p
          *ngIf="this.electronicBillingData.emisorTipo == 5"
          class="paragraph-01-regular data"
        >
          Consumidor final
        </p>
        <p
          *ngIf="this.electronicBillingData.emisorTipo == 6"
          class="paragraph-01-regular data"
        >
          Responsable monotributo
        </p>
      </div>
      <!-- Condición frente al IVA -->
      <!-- CUIT -->
      <div class="item-container">
        <p class="heading-02-bold title">CUIT</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.cuit }}
        </p>
      </div>
      <!-- CUIT -->
      <!-- Ingresos Brutos -->
      <div class="item-container">
        <p class="heading-02-bold title">Ingresos Brutos</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.ingresosBrutos }}
        </p>
      </div>
      <!-- Ingresos Brutos -->
      <!-- Inicio de actividades -->
      <div class="item-container">
        <p class="heading-02-bold title">Inicio de actividades</p>
        <p class="paragraph-01-regular data">
          {{ this.electronicBillingData.inicioActividades }}
        </p>
      </div>
      <!-- Inicio de actividades -->
    </div>
  </div>
</div>
